
































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { mdiClose } from '@mdi/js';

// Static import for faster rendering
import { StickyHeader, Footer } from '@/components/layout';
import { mapActions } from 'vuex';

import { InfosPSBEN } from '@/store/infosPSBEN/types';
import { Motifs } from '@/store/motifs/Motifs';
import { logAcces } from '@/services/api/log/api';
import LogsID from '@/enum/Logs.enum';

import _ from 'lodash';

declare const BRUM_APPDYNAMICS: string;

/** App is the main component */
@Component({
	components: {
		StickyHeader,
		Footer
	},
	methods: {
		...mapActions('globalState', ['addLoading', 'removeLoading', 'updateDataLoaded']),
		...mapActions('infosPSBEN', ['fetchInfosPSBEN']),
		...mapActions('motifs', ['fetchMotifs']),
		...mapActions('motifs', ['fetchMotifsDuMoment']),
		...mapActions('motsIgnores', ['fetchMotsIgnores']),
		...mapActions('motifs', ['fetchListeCategories'])
	}
})
export default class App extends Vue {
	@Getter('globalState/loading') loading!: boolean;
	@Getter('infosPSBEN/getErrorInfosPSBEN') errorPsben!: boolean;
	@Getter('infosPSBEN/getExpirationTs') expirationTs!: number | undefined;
	@Getter('infosPSBEN/getExtensions') extensions!: number | undefined;
	@Getter('infosPSBEN/getDelayDisplaySession') delay!: number | undefined;
	@Getter('infosPSBEN/getExtensionSessionAvailable') extensionSession!: boolean | undefined;
	@Getter('infosPSBEN/getInfosPSBEN') infosPsben!: InfosPSBEN;
	@Getter('motifs/getMotifs') motifs!: Motifs;
	@Getter('motifs/getMotifsDuMoment') motifsDuMoment!: Motifs;
	@Getter('motifs/getListeCategories') listeCategories!: string[];

	userAgent = _.get(window, 'navigator.userAgent', '');
	displayIEMessage = true;
	isExpirationWarningDisplayed = false;
	close = mdiClose;

	displayExpirationWarning() {
		this.isExpirationWarningDisplayed = true;
	}

	// Vérifie si le navigateur est Internet Explorer
	get isIE(): boolean {
		return _.includes(this.userAgent, 'MSIE') || _.includes(this.userAgent, 'Trident/');
	}

	get isPdfLoadingPage() {
		return window.location.pathname.includes('/pdf');
	}

	get isErrorPage() {
		return window.location.pathname.includes('/error');
	}

	createScript(urlAppdyanamicsEnv: string) {
		const scriptDate = document.createElement('script');
		scriptDate.type = 'text/javascript';
		scriptDate.text = 'window[\'adrum-start-time\']=new Date().getTime();';
		scriptDate.onload = _.noop;
		const scriptAppDynamics = document.createElement('script');
		scriptAppDynamics.type = 'text/javascript';
		scriptAppDynamics.setAttribute('src', urlAppdyanamicsEnv );
		scriptAppDynamics.onload = _.noop;
		document.head.appendChild(scriptDate);
		document.head.appendChild(scriptAppDynamics);
	}

	created(): void {
		logAcces(LogsID.FRONT_VERSION);
		if (!this.isErrorPage && !this.isPdfLoadingPage) {
			this.addLoading();

			Promise.all([this.fetchInfosPSBEN(), this.fetchMotifs(), this.fetchMotifsDuMoment(),
				this.fetchMotsIgnores(), this.fetchListeCategories()]).then(() => {
				this.removeLoading();
			}).catch(() => {
				this.removeLoading();
			});

			if (BRUM_APPDYNAMICS) {
				this.createScript(BRUM_APPDYNAMICS);
			}
		}
	}
}
